import { connect } from "react-redux";
import AuthDetails from "../Components";


const mapStateToProps = () => ({
  item: null,
});

export default connect(mapStateToProps)(AuthDetails);